import { Controller } from 'stimulus';

// Mural reaction bar: opens/closes the emoji picker. Each emoji button is a
// button_to that POSTs and re-renders this frame via Turbo Stream, so the
// controller only manages the picker's open/closed state.
export default class extends Controller {
  static targets = ['menu'];

  connect() {
    this.onOutsideClick = this.onOutsideClick.bind(this);
    document.addEventListener('click', this.onOutsideClick);
  }

  disconnect() {
    document.removeEventListener('click', this.onOutsideClick);
  }

  togglePicker(event) {
    event.stopPropagation();
    this.menuTarget.classList.toggle('hidden');
  }

  onOutsideClick(event) {
    if (!this.element.contains(event.target)) this.menuTarget.classList.add('hidden');
  }
}
